module.exports = __webpack_public_path__ + "img/rivenditori-white.20f77eeb.svg";